import React from 'react';
// Constants
import {
  CompanyName,
  KeywordsPages,
  LocationCity,
  MainTitle,
} from '../../utils/Constants';
// Data
import {
  ApplicationPageAdditionalMeta,
  ApplicationPageStructuredData,
} from '../../utils/data/MetaData';
// Components
import Navbar from '../../components/nav/Navbar';
import { HelmetItem } from '../../components/utils/HelmetItem';
import ApplicationPageMainContainer from '../../components/application/ApplicationPageMainContainer';
import GeneralHeader from '../../components/general/GeneralHeader';
// Images
import ApplicationHeaderMain from '../../assets/images/headers/application-misress-sammi-page-header.png';

function ApplicationPage() {
  return (
    <>
      {/* Tab Data */}
      <HelmetItem
        PageName='Questionnaire'
        desc={`${CompanyName} - Exclusive Submissive Application for ${LocationCity}`}
        keywords={KeywordsPages}
        additionalMeta={ApplicationPageAdditionalMeta}
        structuredData={ApplicationPageStructuredData}
      />

      {/* Page */}
      <div className='grid min-h-screen bg-colour2 dark:bg-colour2 text-colour1 dark:text-colour1 w-full h-full font-poppins'>
        <div className='grid h-fit'>
          {/* Navigation */}
          <Navbar />
          <GeneralHeader
            headerMainImage={ApplicationHeaderMain}
            headerMobileImage={ApplicationHeaderMain}
            mainTitle={`${MainTitle}`}
            subtitle={`Apply to become my Submissive`}
          />
        </div>

        {/* Main page content */}
        <ApplicationPageMainContainer />
      </div>
    </>
  );
}

export default ApplicationPage;
